export default __webpack_public_path__ + "static/media/twitchOutline.7a054890.svg";